const faq =
    "https://support.slatedigital.com/hc/en-us/sections/17554856831635-FAQ";

const landingPage = "https://slatedigital.com/virtu/";

export default {
    faq,
    landingPage,
};
